<script>
    import InputPassword from "./InputPassword.svelte";

    /**
     * @typedef {Object} Props
     * @property {any} pin
     * @property {string} [placeholder]
     * @property {string} [showPwLabel]
     * @property {string} [hidePwLabel]
     * @property {boolean} [invalid]
     */

    /** @type {Props & { [key: string]: any }} */
    let {
        pin = $bindable(),
        placeholder = 'Bitte geben Sie Ihre PIN ein.',
        showPwLabel = 'PIN anzeigen',
        hidePwLabel = 'PIN verbergen',
        invalid = $bindable(false),
        ...rest
    } = $props();



    function pinInputChanged() {
        invalid = false;
    }

    $effect(() => {
        pin;
        pinInputChanged();
    });
</script>

<InputPassword
        bind:pw={pin}
        formFeedback="Falsche PIN, bitte geben Sie die PIN erneut ein."
        {invalid}
        {placeholder}
        {showPwLabel}
        {hidePwLabel}
        {...rest}
/>
